<div container>
  <div class="autoantibodies__header mb-5">
    <h2 class="fw-bolder mb-4">What do type 1 diabetes screening results mean?</h2>
    <h3 class="fw-bold mb-3">Interpreting Screening</h3>
    <p class="mb-3">Screening can't prevent T1D, but it can give you time to prepare and consider your options.</p>
    <p class="mb-0">Here we lay out what AAb screening results could mean, and based on those results, we share expert
      recommended next steps. Even if screening comes back negative, you may still want to consider re-screening
      regularly if you or your loved ones have a family history of T1D or other higher risk factors:</p>
  </div>
  <div class="autoantibodies d-flex flex-wrap justify-content-center gap-4">
    <!-- #1 -->
    <div class="card card--1 card--aqua">
      <div class="card__title">
        <h2 class="text-center mb-0"><span class="number">0</span><br />Autoantibodies</h2>
        <hr />
      </div>
      <div class="card__content">
        <p class="mb-4">If the test finds <strong>no sign of T1D now:</strong></p>
        <ul class="mb-0">
          <li>Talk to your doctor about an <strong>appropriate rescreening schedule</strong>, especially if there’s a
            family history of TID. Just because screening didn’t detect T1D-related autoantibodies now <strong>doesn’t
              mean they won’t appear in the future.</strong></li>
        </ul>
      </div>
    </div>

    <!-- #2 -->
    <div class="card card--2 card--purple">
      <div class="card__antibodies">
        <img class="antibodies img-fluid d-none d-lg-block position-absolute"
          [src]="'/assets/img/how-to-screen/antibodies-only.svg'" alt="An autoantibody" width="78" height="78">
      </div>
      <div class="card__title">
        <h2 class="text-center mb-0"><span class="number">1</span><br />Autoantibody</h2>
        <hr />
      </div>
      <div class="card__content mb-3 mb-lg-2">
        <p class="mb-3">If the test finds 1 autoantibody, you or your loved one are at a <strong>higher risk</strong>
          for developing type
          1 diabetes. Talk to your doctor about:</p>
        <ul class="mb-0">
          <li>Ensuring you’ve been <strong>screened for T1D-related autoantibodies</strong></li>
          <li>A <strong>rescreening schedule</strong> as well as <strong>monitoring</strong> and <strong>next
              steps</strong></li>
        </ul>
      </div>
      <!-- <div class="card__footnote d-flex gap-1">
        <span>*</span>
        <span>Glutamic acid decarboxylase 65 (GAD) autoantibodies, Insulinoma-associated antigen 2 autoantibody (1A-2A),
          Zinc transporter 8 autoantibody (ZnT8A), Islet cell autoantibody (ICA), Insulin autoantibody (IAA)</span>
      </div> -->
    </div>

    <!-- #3 -->
    <div class="card card--3 card--orange">
      <div class="card__antibodies">
        <img class="antibodies img-fluid d-none d-lg-block position-absolute"
          [src]="'/assets/img/how-to-screen/antibodies-only.svg'" alt="Two autoantibodies" width="78" height="78">
        <img class="antibodies img-fluid d-none d-lg-block position-absolute"
          [src]="'/assets/img/how-to-screen/antibodies-only.svg'" alt="Two autoantibodies" width="50" height="50">
      </div>
      <div class="card__title">
        <h2 class="text-center mb-0"><span class="number">2+</span><br />Autoantibodies</h2>
        <hr />
      </div>
      <div class="card__content">
        <p class="mb-4">This is a sign that <strong>the earliest stages of type 1 diabetes may have begun:</strong></p>
        <ul class="mb-0">
          <li>See your doctor ASAP to get your blood sugar levels checked, review the results together, and go over
            monitoring/management options and next steps.</li>
        </ul>
      </div>
    </div>
  </div>
</div>